import makeStyles from "@mui/styles/makeStyles";
import { theme } from "../../../App";

const useStyles = makeStyles({
  field: {
    width: "99%",
    maxWidth: "700px",
  },
  helperText: {
    flexGrow: 50,
  },

  helperTextRow: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: 12,
    color: "rgba(0, 0, 0, 0.54)",
    width: "99%",
  },
  helperTextContainer: {
    maxWidth: "75%",
  },
  questionWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  answer: {
    // textAlign: "center",
    width: "100%",
  },
  title: {
    flex: 1,
    fontFamily: "Bogle",
    fontSize: 18,
    fontWeight: 400,
    lineHeight: "33px",
    letterSpacing: 0.25,
    height: 60,
    fontStyle: "normal",
    margin: "0px 9px",
    color: "#4C4C4C",
    [theme.breakpoints.up("sm")]: {
      fontSize: 24,
    },
  },
  subtitle: {
    flex: 1,
    fontFamily: "Bogle-Regular",
    fontSize: 15,
    letterSpacing: 0.25,
    height: 36,
    color: "#8C8C8C",
    margin: "0px 9px",
    [theme.breakpoints.up("sm")]: {
      fontSize: 18,
    },
  },
  customEndpointContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "column",
    paddingBottom: 16,
  },
  customeEndpoint: {
    width: "100%",
    marginRight: 32,
    marginBottom: 12,
  },
  nameInputWrapper: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    margin: "10px",
  },
  oneRowNameInput: {
    margin: "10px !important",
    display: "flex !important",
    width: "unset !important",
  },
  gridWrapper: {
    display: "flex",
    margin: "0px 0px",
    flexDirection: "column",
    [theme.breakpoints.up("sm")]: {
      flexDirection: "row",
      margin: "16px 0px",
    },
  },
  innerGrid: {
    margin: "8px 0px",
  },
  selectMenu: {
    whiteSpace: "normal",
    width: "100%",
  },
  twoRowNameInput: {
    width: "49%",
  },
  threeRowNameInput: {
    width: "32%",
  },
});

export default useStyles;
